module.exports = "/_next/static/images/contact-6c1d210cc5cf0948a8d07e7af343da58.png";